<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="360"
    origin="top center"
    transition="slide-y-transition"
    offset-y
    bottom
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        title="Carrito de compras"
        icon
      >
        <v-badge
          :content="carrito.reduce((sum, carr) => sum + parseInt(carr.cantidad), 0)"
          :value="carrito.reduce((sum, carr) => sum + parseInt(carr.cantidad), 0)"
          color="deep-orange"
          overlap
        >
          <v-icon class="mr-1">fas fa-shopping-cart</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="d-flex align-center py-1">
        <span style="font-size: 18px;">
          Mi Carrito
        </span>
        <v-spacer></v-spacer>
        <v-btn
          small
          icon
          @click="menu = false"
        >
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0 pb-1 px-0 scrollable-content">
        <template v-if="carrito.length > 0">
          <div
            v-for="(item, index) in carrito"
            :key="index"
          >
            <v-divider></v-divider>
            <v-card
              class="d-flex"
              flat
            >
              <v-list-item-avatar
                tile
                size="60"
                class="ml-3"
                color="disabled"
                outlined
              >
                <img v-if="item.base64" :src="`data:image/jpeg;base64,${item.base64}`" />
                <v-icon v-else x-large>fas fa-images</v-icon>
              </v-list-item-avatar>
              <div style="width: 100%;">
                <div
                  class="py-2 pr-2"
                  :title="item.articulo_nombre.length > ($vuetify.breakpoint.xs ? 30 : 40) ? item.articulo_nombre : ''"
                >
                  {{ item.articulo_nombre.substring(0, ($vuetify.breakpoint.xs ? 30 : 40)) }}
                  {{ item.articulo_nombre.length > ($vuetify.breakpoint.xs ? 30 : 40) ? '...' : '' }}
                </div>
                <div class="d-flex align-center">
                  <div class="d-flex align-center">
                    <v-btn
                      v-if="!$vuetify.breakpoint.xs"
                      color="primary"
                      x-small
                      icon
                      @click="item.cantidad > 1 ? item.cantidad-- : ''"
                    >
                      <v-icon x-small>fas fa-minus</v-icon>
                    </v-btn>
                    <v-text-field
                      v-model="item.cantidad"
                      type="number"
                      class="mx-1"
                      style="width: 50px;"
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-btn
                      v-if="!$vuetify.breakpoint.xs"
                      color="primary"
                      class="mr-1"
                      x-small
                      icon
                      @click="item.cantidad < item.stock ? item.cantidad++ : ''"
                    >
                      <v-icon x-small>fas fa-plus</v-icon>
                    </v-btn>
                  </div>
                  <v-btn
                    class="text-none ml-2"
                    title="Eliminar del carrito"
                    color="primary"
                    x-small
                    icon
                    @click="quitarCarrito(item)"
                  >
                    <v-icon x-small>fas fa-trash</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <span class="body-1 font-weight-medium mr-4">
                    {{ formatMoney(item.precio_unitario * parseInt(item.cantidad)) }}
                  </span>
                </div>
              </div>
            </v-card>
          </div>
        </template>
        <v-alert
          v-else
          type="info"
          class="mx-3"
          border="left"
          text
        >
          <div class="text-center">
            <div>
              No se agregaron artículos al carrito
            </div>
            <v-btn
              color="info"
              class="mt-3"
              outlined
              small
              to="/ecommerce"
              @click="menu = false"
            >
              {{ $route.name == 'Ecommerce' ? 'Seguir comprando' : 'Empezar a comprar' }}
            </v-btn>
          </div>
        </v-alert>
      </v-card-text>
      <template v-if="carrito.length > 0">
        <v-divider></v-divider>
        <v-card-text class="d-flex justify-center pt-1 pb-0">
          {{ carrito.reduce((sum, carr) => sum + parseInt(carr.cantidad), 0) }} artículo(s) seleccionados
        </v-card-text>
        <v-card-title class="py-0">
          Subtotal
          <v-spacer></v-spacer>
          {{ formatMoney(carrito.reduce((sum, carr) => sum + (parseInt(carr.cantidad) * parseFloat(carr.precio_unitario)), 0)) }}
        </v-card-title>
        <v-card-actions class="d-flex align-center py-3">
          <v-btn
            color="primary"
            class="text-none"
            x-small
            text
            @click="limpiar()"
          >
            Limpiar Carrito
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-3"
            to="/checkout"
          >
            Finalizar Compra
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import { format_money } from '../../util/utils'

export default {
  data () {
    return {
      formatMoney: format_money,
      menu: false
    }
  },
  computed: {
    ...mapState(['carrito'])
  },
  methods: {
    quitarCarrito (item) {
      const index = this.carrito.indexOf(item)
      this.carrito.splice(index, 1)
    },
    limpiar () {
      this.$store.state.carrito = []
    }
  }
}
</script>